module.exports = __webpack_public_path__ + "static/media/perfect-gold_00004.37684a6f.png";